import OperationsTableContainer from 'presentation/containers/modules/operations/OperationsTableContainer';
import PortfolioPageLayout from 'presentation/layout/modules/portfolio/PortfolioPageLayout';
import { FC } from 'react';

const OperationsPage: FC = () => {
  return (
    <PortfolioPageLayout>
      <OperationsTableContainer/>
    </PortfolioPageLayout>
  );
};

export default OperationsPage;
